import { render } from "./VolunteerFDList.vue?vue&type=template&id=b1765546&scoped=true"
import script from "./VolunteerFDList.vue?vue&type=script&lang=js"
export * from "./VolunteerFDList.vue?vue&type=script&lang=js"

import "./VolunteerFDList.vue?vue&type=style&index=0&id=b1765546&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1765546"]])

export default __exports__